import type { WebChannelAnalyticsConfig } from '@repo/api/web/models'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { StoredConsent } from '../models'

export const useAnalyticsStore = defineStore('analytics', () => {
  const config = ref<WebChannelAnalyticsConfig>()

  /** Актуальное (не протухшее по TTL) решение пользователя; null — не принято */
  const consent = ref<StoredConsent | null>(null)

  function setConfig(newConfig: WebChannelAnalyticsConfig) {
    config.value = newConfig
  }

  function setConsent(newConsent: StoredConsent | null) {
    consent.value = newConsent
  }

  return {
    config,
    consent,
    setConfig,
    setConsent,
  }
})
